"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var filter_dto_builder_1 = require("../builder/filter-dto-builder");
var filter_dto_1 = require("./filter-dto");
/**
 * Patterned search filter. Selects values sets which match the pattern <CODE>.*value.*</CODE>
 *
 * Created by Hayk.Andriasyan on 6/1/2017.
 */
var EndsWithFilterDto = /** @class */ (function (_super) {
    __extends(EndsWithFilterDto, _super);
    function EndsWithFilterDto(pathHolderId, value) {
        var _this = _super.call(this, filter_dto_builder_1.FilterDtoBuilder.FILTER, EndsWithFilterDto.ENDS_WITH) || this;
        _this.pathHolderId = pathHolderId;
        _this.value = value;
        return _this;
    }
    EndsWithFilterDto.ENDS_WITH = 'endsWith';
    return EndsWithFilterDto;
}(filter_dto_1.FilterDto));
exports.EndsWithFilterDto = EndsWithFilterDto;
//# sourceMappingURL=ends-with-filter-dto.js.map